import { useEffect } from "react"
import { usePage } from "@inertiajs/react"
import { applyAccent } from "@/lib/accents"
import type { PageProps } from "@/types/inertia"

/**
 * Keeps <html data-accent> in step with the signed-in user's accent. The server
 * sets it on a full page load; this covers Inertia navigations that don't
 * re-render the layout, such as signing out or changing the color.
 */
export function AccentSync() {
  const accent = usePage<PageProps>().props.current_user?.accent ?? null
  useEffect(() => applyAccent(accent), [accent])
  return null
}
